import { Link } from "react-router-dom";
import { Chip, Rows } from "rothzerg-ui";
import { searchPath } from "@/lib/routes";

type RelatedSearchTagsProps = {
  terms: string[];
};

export function RelatedSearchTags({ terms }: RelatedSearchTagsProps) {
  if (!terms.length) return null;

  return (
    <Rows gap="sm" id="related-search-tags">
      <span style={{ fontSize: "0.875rem", color: "var(--rz-color-muted-foreground)" }}>
        Related searches:
      </span>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
        {terms.map((term) => (
          <Link key={term} to={searchPath(term)}>
            <Chip label={term} variant="outline" size="sm" />
          </Link>
        ))}
      </div>
    </Rows>
  );
}
